import { render, staticRenderFns } from "./AvitoAreaEdit.vue?vue&type=template&id=489743d9&"
import script from "./AvitoAreaEdit.vue?vue&type=script&lang=js&"
export * from "./AvitoAreaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports